import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SellingCompanyWarehouseConnection } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class SellingCompanyWarehouseConnectionService extends TmsWebBaseEditCreateService<
  SellingCompanyWarehouseConnection,
  SellingCompanyWarehouseConnection
> {
  constructor() {
    super('SellingCompanyWarehouseConnection', $localize`Selling Company Warehouse Connection`);
  }

  getForSellingCompany(id: string): Observable<SellingCompanyWarehouseConnection[]> {
    return this.httpService.get<SellingCompanyWarehouseConnection[]>(
      `${this.apiUrl}/GetForSellingCompanyWarehouse?id=${id}`,
    );
  }
}
